{
  "version": "v4.3.0",
  "name": "LiquidityAmountsTest",
  "bytecode": "0006402e405240a440d241b441d701000304010dd3b8a5f4fb1600160113c9010000000000000000000000000004170316021603160116002b000402010003030108d364be47fc160213c901000000000000000000000000160116002b00040201000507014027d345f12d7a16001601324c061601160216030000024a1c16001602314c13160016021603000017051601160016040001170616051606314c0216054a011606024a0516011602160400010201000304010ed374e08b3b160213c9010000000000000000000000002c160116002b160100041703160316002d020000030901408d160016010c0d3687170316001601371704160316043616031604314c020d4a010c36170516050c2f4c04160416022d02160216053313415f7b160016011602871706160516061604334c020d4a010c361705160416063617040c1602361602381707160216072d1702160416072d17040c16073616072d0d351707160416051607373917040f1602370e3a170816080e16021608373637170816080e16021608373637170816080e16021608373637170816080e16021608373637170816080e16021608373637170816080e16021608373637170816041608370200000304011216001601160200041703160016011602870c334c0416030d2a02160302",
  "codeHash": "6a4ba04c81892909e02efe02e9f3ebf139cf27afd40f5fca01f4a9b98a9003da",
  "fieldsSig": {
    "names": [],
    "types": [],
    "isMutable": []
  },
  "eventsSig": [],
  "functions": [
    {
      "name": "getLiquidityForAmount0",
      "paramNames": [
        "sqrtRatioAX96",
        "sqrtRatioBX96",
        "amount0"
      ],
      "paramTypes": [
        "U256",
        "U256",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false,
        false
      ],
      "returnTypes": [
        "U256"
      ]
    },
    {
      "name": "getLiquidityForAmount1",
      "paramNames": [
        "sqrtRatioAX96",
        "sqrtRatioBX96",
        "amount1"
      ],
      "paramTypes": [
        "U256",
        "U256",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false,
        false
      ],
      "returnTypes": [
        "U256"
      ]
    },
    {
      "name": "getLiquidityForAmounts",
      "paramNames": [
        "sqrtRatioX96",
        "sqrtRatioAX96",
        "sqrtRatioBX96",
        "amount0",
        "amount1"
      ],
      "paramTypes": [
        "U256",
        "U256",
        "U256",
        "U256",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false,
        false,
        false,
        false
      ],
      "returnTypes": [
        "U256"
      ]
    },
    {
      "name": "getAmount0ForLiquidity",
      "paramNames": [
        "sqrtRatioAX96",
        "sqrtRatioBX96",
        "liquidity"
      ],
      "paramTypes": [
        "U256",
        "U256",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false,
        false
      ],
      "returnTypes": [
        "U256"
      ]
    },
    {
      "name": "mulDiv",
      "paramNames": [
        "a",
        "b",
        "denominator"
      ],
      "paramTypes": [
        "U256",
        "U256",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false,
        true
      ],
      "returnTypes": [
        "U256"
      ]
    },
    {
      "name": "mulDivRoundingUp",
      "paramNames": [
        "a",
        "b",
        "denominator"
      ],
      "paramTypes": [
        "U256",
        "U256",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false,
        false
      ],
      "returnTypes": [
        "U256"
      ]
    }
  ],
  "constants": [],
  "enums": [
    {
      "name": "FullMathError",
      "fields": [
        {
          "name": "MulDivOverflow",
          "value": {
            "type": "U256",
            "value": "351"
          }
        }
      ]
    }
  ]
}